import { render, staticRenderFns } from "./TabelaEscore.vue?vue&type=template&id=1ca5f1f1&scoped=true"
import script from "./TabelaEscore.vue?vue&type=script&lang=js"
export * from "./TabelaEscore.vue?vue&type=script&lang=js"
import style0 from "./TabelaEscore.vue?vue&type=style&index=0&id=1ca5f1f1&prod&lang=css"
import style1 from "./TabelaEscore.vue?vue&type=style&index=1&id=1ca5f1f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5f1f1",
  null
  
)

export default component.exports